import http from "../http-common";
import IDraftData from "../types/DraftData";
import IDraftRequest from "../types/DraftRequest";

const getAll = (token?: string) => {
  const result = http.get<Array<IDraftData>>('/api/Draft', {
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {}
  });

  return result;
};

const create = (requestBody: IDraftRequest, token?: string) => {
  return http.post<IDraftRequest>(
    '/api/Draft',
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  )
};

const modify = (requestBody: IDraftRequest, token?: string) => {
  return http.put<IDraftRequest>(
    '/api/Draft/modify',
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  )
};

const remove = (id: number, token?: string) => {
  return http.delete<any>(`/api/Draft/${id}`, {
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {}
  });
};

const clearAll = (token?: string) => {
  return http.delete<any>(`/api/Draft/deleteAll`, {
    headers: token ? {
      Authorization: `Bearer ${token}`
    } : {}
  });
};

const DraftService = {
  getAll,
  create,
  modify,
  remove,
  clearAll
};

export default DraftService;